import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { API_URL_FELL } from 'config';
import { GetCalculationPayload } from 'lib/types';

export const getCalculation = createAsyncThunk<
    GetCalculationPayload,
    { projectId: string; siteId: string; siteDesignId: string },
    { rejectValue: GetCalculationPayload }
>('proposals/getCalculation', async ({ projectId, siteId, siteDesignId }, { rejectWithValue }) => {    
    try {        
        const apiResponse = await axios.get(
            `${API_URL_FELL()}/project/${projectId}/site/${siteId}/sitedesign/${siteDesignId}/calculate`
        );       
        return { data: apiResponse.data };
    } catch (err) {
        console.log('err')
        const error: AxiosError<string> = err;
        return rejectWithValue({ error: error.message });
    }
});
